import React from "react";
import {
  Box,
  ButtonBase,
  Stack,
  Typography
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { Colors } from "../utils/colors";

export const DEFAULT_PROFILE_FALLBACK_ROUTE = "/account/authmenu";

export default function BackHeader({
  title,
  fallbackRoute = DEFAULT_PROFILE_FALLBACK_ROUTE,
  sx = {},
  titleSx = {},
  showBackLabel = true
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(fallbackRoute, { replace: true });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{ xs: 1, sm: 1.5 }}
      sx={{
        mb: 3,
        flexWrap: "wrap",
        rowGap: 1,
        ...sx
      }}
    >
      <ButtonBase
        onClick={handleBack}
        aria-label="Go back"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1.25,
          py: 0.85,
          borderRadius: 999,
          color: Colors.whitesmoke,
          border: "1px solid rgba(255,255,255,0.14)",
          backgroundColor: "rgba(255,255,255,0.06)",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.12)"
          },
          "&:focus-visible": {
            outline: `2px solid ${Colors.accent}`,
            outlineOffset: 2
          }
        }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
        {showBackLabel && (
          <Typography
            component="span"
            sx={{
              fontSize: { xs: 13, sm: 14 },
              fontWeight: 700
            }}
          >
            Back
          </Typography>
        )}
      </ButtonBase>

      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="h5"
          fontWeight={800}
          sx={{
            color: Colors.whitesmoke,
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
            lineHeight: 1.2,
            wordBreak: "break-word",
            ...titleSx
          }}
        >
          {title}
        </Typography>
      </Box>
    </Stack>
  );
}
